/* LoginFormRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;
const InputPaswordControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputPassword;
const InputEmailControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputEmail;
const InputRadioControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .InputRadio;
const _ = require("lodash");

class LoginFormRenderer {
    constructor(model) {
        this._model = model;
        this._needHelpOption = undefined;

        this._rootElement = document.createElement("login-form");
        this._rootElement.component = model;

        this._brandingContainer = document.createElement("branding-container-gl");
        this._controlsContainer = document.createElement("controls-container-gl");

        // LOGO
        this._loginLogo = document.createElement("login-logo-gl");

        // NEED HELP BUTTON
        this._needHelpBtn = new ButtonControl({
            darkTheme: true,
            label: "Need Help?",
        });

        // NEED HELP CONTAINER
        this._needHelpContainer = document.createElement("need-help-container");

        // USERNAME INPUT
        this._usernameInput = new InputTextControl({
            placeholder: "Username",
            autocompleteHint: "username",
        });
        this._usernameInput.setAttribute("name", "username");

        // PASSWORD INPUT
        this._passwordInput = new InputPaswordControl({
            placeholder: "Password",
            autocompleteHint: "current-password",
        });
        this._passwordInput.setAttribute("name", "password_current");

        // LOGIN BUTTON CONTAINER
        this._loginBtnContainer = document.createElement("div");
        this._loginBtnContainer.classList.add("login-btn-container");

        // LOGIN BUTTON
        this._loginBtn = new ButtonControl({
            label: "Sign In",
            active: true,
            disabled: true,
        });
        this._loginBtn.renderer.rootElement.classList.add("login-button");
        this._loginBtnContainer.appendChild(this._loginBtn.renderer.rootElement);

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _clearMessages() {
        if (this._rootElement.contains(this._errorMsgEl)) {
            this._errorMsgEl.remove();
            this._errorMsgEl = null;
        }
        if (this._rootElement.contains(this._infoMsgEl) && !this._model._isChallengeForm) {
            this._infoMsgEl.remove();
            this._infoMsgEl = null;
        }
    }

    _clearPassword() {
        if (this._passwordInput) {
            this._passwordInput.value = "";
            this._passwordInput.focus();
        }
    }

    _onRequestLogin() {
        this._clearMessages();
        this._hideHelpView();
        let username = this._usernameInput.value;
        let password = this._passwordInput.value;
        if (username && password) {
            this._model.loginRequest(username, password);
        }
    }

    _onRequestHelp() {
        if (this._needHelpPwdOptionRadio.value) {
            this._model.passwordRequest(this._needHelpEmailInput.value);
        } else if (this._needHelpUserOptionRadio.value) {
            this._model.usernameRequest(this._needHelpEmailInput.value);
        }
    }

    _onForgotPasswordRadioClick() {
        if (this._needHelpUserOptionRadio) {
            this._needHelpUserOptionRadio.value = undefined;
        }
        this._removeHelpForm();
        this._renderHelpForm("password");
        this._needHelpOptions.appendChild(this._needHelpForm);
    }

    _onForgotUsernameRadioClick() {
        if (this._needHelpPwdOptionRadio) {
            this._needHelpPwdOptionRadio.value = undefined;
        }
        this._removeHelpForm();
        this._renderHelpForm("username");
        let needHelpPwdOptionContainer =
            this._needHelpOptions.querySelector("need-help-pwd-option");
        this._needHelpOptions.insertBefore(this._needHelpForm, needHelpPwdOptionContainer);
    }

    _renderHelpForm(type) {
        // NEED HELP FORM
        this._needHelpForm = document.createElement("need-help-form");

        // HELP REQUEST FORM
        this._helpRequestForm = document.createElement("help-request-form");
        this._needHelpForm.appendChild(this._helpRequestForm);

        // DESCRIPTION
        this._helpRequestFormDescription = document.createElement("p");
        this._helpRequestFormDescription.innerHTML = `Retrieve your ${type} by entering the email address you used to sign in to Gluware.`;
        this._helpRequestForm.appendChild(this._helpRequestFormDescription);

        // NEED HELP EMAIL INPUT
        this._needHelpEmailInput = new InputEmailControl({});
        this._needHelpEmailInput.on(
            "UserValue",
            (this._onEmailInput = this._onEmailInput.bind(this))
        );
        this._helpRequestForm.appendChild(this._needHelpEmailInput.renderer.rootElement);

        // NEED HELP REQUEST BUTTON
        this._needHelpRequestBtn = new ButtonControl({
            label: "Continue",
        });
        this._needHelpRequestBtn.on(
            "UserClick",
            (this._onRequestHelp = this._onRequestHelp.bind(this))
        );
        this._helpRequestForm.appendChild(this._needHelpRequestBtn.renderer.rootElement);
    }

    _removeHelpForm() {
        if (this._needHelpEmailInput) {
            this._needHelpEmailInput.shutdown();
            this._needHelpRequestBtn.shutdown();
            this._needHelpEmailInput = null;
            this._needHelpRequestBtn = null;
        }
        if (this._needHelpForm) {
            this._needHelpForm.remove();
            this._needHelpForm = null;
        }
    }

    _onCheckEnterValue(evt) {
        if (evt.keyCode === 13) {
            this._onRequestLogin();
        }
    }

    _onPasswordInput() {
        this._setButtonState();
        this._clearMessages();
        this._hideHelpView();
    }

    _onUsernameInput() {
        this._setButtonState();
        this._clearMessages();
        this._hideHelpView();
    }

    _setButtonState() {
        if (_.isEmpty(this._passwordInput.value) || _.isEmpty(this._usernameInput.value)) {
            this._loginBtn.setDisabled(true);
        } else {
            this._loginBtn.setDisabled(false);
        }
    }

    _hideHelpView() {
        this._removeHelpOptions();
    }

    _changeFormToChallenge() {
        this._usernameInput.setVisible(false);
        this._needHelpBtn.setVisible(false);
        this._needHelpContainer.classList.add("hidden");
        this._usernameInput.setDisabled(true);
        this._passwordInput.setPlaceholder("Authentication Code");
        this._passwordInput.setAttribute("type", "text");
        this._passwordInput.setAttribute("autocomplete", "one-time-code");

        this._loginBtnContainer.classList.add("half-btn");
        this._loginBtn.renderer.rootElement.classList.add("login-btn-half");

        if (!this._cancelBtn) {
            this._cancelBtn = new ButtonControl({
                label: "Cancel",
                active: true,
                disabled: false,
                class: "cancel-btn-half",
            });

            this._loginBtnContainer.appendChild(this._cancelBtn.renderer.rootElement);
            this._cancelBtn.on(
                "UserClick",
                (this._changeChallengeToNormal = this._changeChallengeToNormal.bind(this))
            );
        }
    }

    _changeChallengeToNormal() {
        this._model._isChallengeForm = false;

        this._usernameInput.setVisible(true);
        this._needHelpBtn.setVisible(true);
        this._needHelpContainer.classList.remove("hidden");
        this._usernameInput.setDisabled(false);
        this._usernameInput.value = "";
        this._passwordInput.setPlaceholder("Password");
        this._passwordInput.setAttribute("type", "password");
        this._passwordInput.renderer.rootElement.removeAttribute("autocomplete");
        this._loginBtnContainer.classList.remove("half-btn");
        this._loginBtn.renderer.rootElement.classList.remove("login-btn-half");
        this._cancelBtn.removeListener("UserClick", this._changeChallengeToNormal);
        this._cancelBtn.shutdown();
        this._cancelBtn = undefined;
        this._clearMessages();
    }

    _removeHelpOptions() {
        this._removeHelpForm();
        if (this._needHelpOptions) {
            if (this._needHelpUserOptionRadio) {
                this._needHelpUserOptionRadio.shutdown();
                this._needHelpUserOptionRadio = null;
            }
            if (this._needHelpPwdOptionRadio) {
                this._needHelpPwdOptionRadio.shutdown();
                this._needHelpPwdOptionRadio = null;
            }
            this._needHelpOptions.remove();
            this._needHelpUserOption = null;
            this._needHelpPwdOption = null;
            this._needHelpOptions = null;
        }
    }

    _renderHelpOptions() {
        // NEED HELP OPTIONS
        this._needHelpOptions = document.createElement("need-help-options");

        // NEED HELP USER OPTION
        this._needHelpUserOption = document.createElement("need-help-user-option");
        this._needHelpOptions.appendChild(this._needHelpUserOption);

        // NEED HELP USER OPTION RADIO
        this._needHelpUserOptionRadio = new InputRadioControl({
            name: "help-options",
            options: [
                {
                    label: "Forgot my username",
                    value: "1",
                },
            ],
        });
        this._needHelpUserOptionRadio.on(
            "UserValue",
            (this._onForgotUsernameRadioClick = this._onForgotUsernameRadioClick.bind(this))
        );
        this._needHelpUserOption.appendChild(this._needHelpUserOptionRadio.renderer.rootElement);

        // NEED HELP PWD OPTION
        this._needHelpPwdOption = document.createElement("need-help-pwd-option");
        this._needHelpOptions.appendChild(this._needHelpPwdOption);

        // NEED HELP PWD OPTION RADIO
        this._needHelpPwdOptionRadio = new InputRadioControl({
            name: "help-options",
            options: [
                {
                    label: "Forgot my password",
                    value: "1",
                },
            ],
        });
        this._needHelpPwdOptionRadio.on(
            "UserValue",
            (this._onForgotPasswordRadioClick = this._onForgotPasswordRadioClick.bind(this))
        );
        this._needHelpPwdOption.appendChild(this._needHelpPwdOptionRadio.renderer.rootElement);

        this._controlsContainer.insertBefore(
            this._needHelpOptions,
            this._needHelpContainer.nextSibling
        );
    }

    _toggleHelpView() {
        if (this._rootElement.contains(this._needHelpOptions)) {
            this._removeHelpOptions();
        } else {
            this._renderHelpOptions();
        }
        this._clearMessages();
    }

    _onEmailInput() {
        this._clearMessages();
    }

    // ERROR MESSAGE
    _msgError(msg) {
        if (msg) {
            this._renderErrorMsg(msg);
        } else {
            this._removeErrorMsg();
        }
    }

    _renderErrorMsg(msg) {
        if (!this._errorMsgEl) {
            this._errorMsgEl = document.createElement("error-msg");
            this._controlsContainer.insertBefore(this._errorMsgEl, this._loginBtnContainer);
        }
        this._errorMsgEl.innerHTML = msg;
    }

    _removeErrorMsg() {
        if (this._errorMsgEl) {
            if (this._errorMsgEl.parentNode) {
                this._errorMsgEl.parentNode.removeChild(this._errorMsgEl);
            }
            this._errorMsgEl = null;
        }
    }

    // INFO MESSAGE
    _msgInfo(msg) {
        if (msg) {
            this._renderInfoMsg(msg);
        } else {
            this._removeInfoMsg();
        }
    }

    _renderInfoMsg(msg) {
        if (!this._infoMsgEl) {
            this._infoMsgEl = document.createElement("info-msg");
            this._controlsContainer.insertBefore(this._infoMsgEl, this._loginBtnContainer);
        }
        this._infoMsgEl.innerHTML = msg;
    }

    _removeInfoMsg() {
        if (this._infoMsgEl) {
            if (this._infoMsgEl.parentNode) {
                this._infoMsgEl.parentNode.removeChild(this._infoMsgEl);
            }
            this._infoMsgEl = null;
        }
    }

    shutdown() {
        this._unregisterListeners();
        let promArr = [
            this._loginBtn.shutdown(),
            this._usernameInput.shutdown(),
            this._passwordInput.shutdown(),
        ];

        return Promise.all(promArr).then(
            () => {
                this._loginBtn = undefined;
                this._usernameInput = undefined;
                this._passwordInput = undefined;
                this._needHelpBtn = undefined;
                this._model = undefined;
                this._rootElement.remove();
                this._rootElement = undefined;
            },
            (err) => {
                console.log("Error shutting down LoginFormRenderer: ", err);
            }
        );
    }

    _registerListeners() {
        this._model.on("msg-error", (this._msgError = this._msgError.bind(this)));
        this._model.on("msg-info", (this._msgInfo = this._msgInfo.bind(this)));
        this._model.on("clear-password", (this._clearPassword = this._clearPassword.bind(this)));
        this._model.on("help.hide", (this._hideHelpView = this._hideHelpView.bind(this)));
        this._model.on(
            "ChangeFormToChallenge",
            (this._changeFormToChallenge = this._changeFormToChallenge.bind(this))
        );
        this._loginBtn.on("UserClick", (this._onRequestLogin = this._onRequestLogin.bind(this)));
        this._needHelpBtn.on("UserClick", (this._toggleHelpView = this._toggleHelpView.bind(this)));
        this._passwordInput.on(
            "UserValue",
            (this._onPasswordInput = this._onPasswordInput.bind(this))
        );
        this._passwordInput.on(
            "UserKeyDown",
            (this._onCheckEnterValue = this._onCheckEnterValue.bind(this))
        );
        this._usernameInput.on(
            "UserValue",
            (this._onUsernameInput = this._onUsernameInput.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeListener("msg-error", this._msgError);
        this._model.removeListener("msg-info", this._msgInfo);
        this._model.removeListener("clear-password", this._clearPassword);
        this._model.removeListener("help.hide", this._hideHelpView);
        this._loginBtn.removeListener("UserClicked", this._onRequestLogin);
        this._needHelpBtn.removeListener("UserClick", this._toggleHelpView);
        this._passwordInput.removeListener("UserValue", this._onPasswordInput);
        this._passwordInput.removeListener("UserKeyDown", this._onCheckEnterValue);
        this._usernameInput.removeListener("UserValue", this._onUsernameInput);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     */
    render() {
        if (!this._rootElement.hasChildNodes()) {
            this._brandingContainer.appendChild(this._loginLogo);
            this._needHelpContainer.appendChild(this._needHelpBtn.renderer.rootElement);
            this._controlsContainer.appendChild(this._usernameInput.renderer.rootElement);
            this._controlsContainer.appendChild(this._passwordInput.renderer.rootElement);
            this._controlsContainer.appendChild(this._needHelpContainer);
            this._controlsContainer.appendChild(this._loginBtnContainer);
            this._rootElement.appendChild(this._brandingContainer);
            this._rootElement.appendChild(this._controlsContainer);
        }
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElement;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}
module.exports = LoginFormRenderer;
